<script>
import { mapActions, mapState } from 'vuex';
import {
    UI_MAP_READY,
    UI_MAP_LOADED,
    UI_STEP_SELECTED,
    MAP_OBJECT_HOVERED,
    MAP_SHOW_PATH_STEPS,
    MAP_OBJECT_SELECTED
} from "../../../shared/components/map-viewer/constants/map-events";

import {
    osName, 
    osVersion,
    browserName,
    fullBrowserVersion
} from 'mobile-device-detect';

import {
    SUCCESS_SEARCH,
    UNSUCCESS_SEARCH,
    NO_DIRECT_MATCHES,
    SEARCH_DATA_CHANGE,
    CHECK_SEARCH_VALUE,
    ERASE_SEARCH_STRING,
} from '../../../utils/constants/bus-events-constants'

export default {
    name: "OStatisticsController",

    data() {
        return {
            mapStartLoadingTime: 0,
            searchData: {}
        }
    },
    computed: {
        ...mapState([
            'sessionId',
            'activePath'
        ])
    },
    methods: {
        ...mapActions([
            "sendEvent",
            "sendEvents",
            "sendGuideEvent",
            "sendSearchEvent",
            "sendGuideStepEvent",
            "sendObjectClickEvent",
            "sendObjectHoverEvent",
            "sendCategoryClickEvent"
        ]),
        onMapReady() {
            const mapLoadingTime = new Date().getTime() - this.mapStartLoadingTime;
            const targetId = this.$route.query.t || this.$route.query.mTo;
            const eventCategory = this.getRouteQuery() || 'map'; 
            const event = {
                event_category : eventCategory,
                event: 'app-loaded',
                source_id: targetId,
                target_id: mapLoadingTime,
                target: targetId && 'object',
                value1: navigator.userAgent,
                value2: `${osName},${osVersion}`,
                value3: fullBrowserVersion,
            }
            
            this.sendEvent(event)
            this.$bus.$off(UI_MAP_READY, this.onMapReady);
        },
        onMapLoaded(){
            this.mapStartLoadingTime = new Date().getTime()
        },
        sendUIGuideStepEvent (stepIndex) {
            this.sendGuideStepEvent({stepIndex, eventCategory: 'ui'})
        },
        sendMapGuideStepEvent (stepIndex) {
            this.sendGuideStepEvent({stepIndex, eventCategory: 'map'})
        },
        searchDataChange(newData) {
            this.searchData = newData
        },
        sendEraseSearchStringEvent(data) {
            this.sendSearchEvent(data)
        },
        sendUnsuccessSearchEvent() {
            this.sendSearchEvent({
                value1: this.searchData.searchValue || this.searchData.oldValue,
                value2: "not_found",
                value3: "leave",
                target_id: this.searchData.categoryId || this.searchData.searchResultsCount,
                target: this.searchData.categoryId ? 'category' : ''
            })
        },
        sendSuccessSearchEvent(data) {
            this.sendSearchEvent(data)
        },
        getRouteQuery() {
            if(
                this.$route.query['redirect-from']
                && (this.$route.query['redirect-from'] === 'sms' || this.$route.query['redirect-from'] === 'qr')
            ) {
                return this.$route.query['redirect-from']
            } else {
                return false
            }
        },
        checkSearchValue() {
            this.searchData.searchValue && this.sendUnsuccessSearchEvent()
            this.searchData = {}
        },
        noDirectMatches() {
            this.sendSearchEvent({
                value1: this.searchData.searchValue || this.searchData.oldValue,
                value2: "not_found",
                value3: 'no_direct_matches',
                target_id: this.searchData.categoryId || this.searchData.searchResultsCount,
                target: this.searchData.categoryId ? 'category' : ''
            })
        },
        checkStorageOfflineEvents() {
            const storageOfflineEvents = this.getOfflineEvents();

            if(storageOfflineEvents) {
                this.sendEvents();
            }
        },
        isOnline(){
            return window.navigator.onLine;
        },
        getOfflineEvents() {
            const events = localStorage?.getItem('offlineEvents');
            return events ? JSON.parse(events) : false;
        },
        sendViewEvent() {
            const targetId = this.$route.query.t || this.$route.query.mTo;
            const eventCategory = this.getRouteQuery() || 'ui';
            let target = targetId && 'object';
            let targetType = ''

            switch (this.$route.name) {
                case 'terminal.start' || 'terminal.searchbar':
                    target = 'page';
                    targetType = 'catalog';
                    break
                case 'terminal.tiles':
                    target = this.$route.params.categoryId;
                    targetType = 'catalog';
                    break
                case 'web.integration.catalogue.info' || 'web.integration.store.info':
                    target = 'tenant';
                    targetType = 'object';
                    break
                case 'web.integration.catalogue.list':
                    target = 'page';
                    targetType = 'catalog';
                    break
                default:
                    target = '';
                    targetType = '';
            }

            const event = {
                event_category : eventCategory,
                event: 'view',
                target_id: targetId,
                target,
                target_type: targetType
            }

            this.sendEvent(event)
        }
    },
    watch:{
        //activePath: 'sendGuideEvent'
        activePath(activePath, oldActivePath){
            if(
                activePath && !_.isEqual(activePath, oldActivePath)
            ) {
                const routeQuery = this.getRouteQuery();
                if (routeQuery) {
                    this.sendGuideEvent({
                        guide: this.activePath,
                        params: {
                            event: "guide",
                            event_category: routeQuery,
                        }
                    })
                } else {
                    this.sendGuideEvent({
                        guide: activePath,
                        params: {
                            event: "guide",
                            event_category: "ui",
                        }
                    })
                }
            }
        },
        '$route': {
            handler(newRoute, oldRoute) {
                if(
                    oldRoute?.name === 'terminal.searchbar'
                    && newRoute.name !== 'terminal.guide'
                    && newRoute.name !== 'terminal.standard.guide'
                    && newRoute.name !== 'terminal.service'
                ) {
                    this.checkSearchValue()
                } else if (
                    this.searchData.searchValue
                    && oldRoute?.name === 'mobile.search'
                    && newRoute.name !== 'mobile.guide'
                    && newRoute.name !== 'mobile.service'

                ) {
                    this.sendUnsuccessSearchEvent()
                }

                if(
                    newRoute.name === 'terminal.start'
                    || newRoute.name === 'terminal.searchbar'
                    || newRoute.name === 'terminal.tiles'
                    || newRoute.name === 'web.integration.catalogue.info'
                    || newRoute.name === 'web.integration.catalogue.list'
                    || newRoute.name === 'web.integration.store.info'
                ) {
                    this.sendViewEvent()
                }
            },
            immediate: true
        }
    },
    created(){
        this.$bus.$on(UI_MAP_READY, this.onMapReady);
        this.$bus.$on(UI_MAP_LOADED, this.onMapLoaded);
        this.$bus.$on(UI_STEP_SELECTED, this.sendUIGuideStepEvent);

        this.$bus.$on(MAP_OBJECT_HOVERED, this.sendObjectHoverEvent);
        this.$bus.$on(MAP_OBJECT_SELECTED, this.sendObjectClickEvent);
        this.$bus.$on(MAP_SHOW_PATH_STEPS, this.sendMapGuideStepEvent);

        this.$bus.$on(NO_DIRECT_MATCHES, this.noDirectMatches);
        this.$bus.$on(SEARCH_DATA_CHANGE, this.searchDataChange);
        this.$bus.$on(CHECK_SEARCH_VALUE, this.checkSearchValue);
        this.$bus.$on(SUCCESS_SEARCH, this.sendSuccessSearchEvent);
        this.$bus.$on(UNSUCCESS_SEARCH, this.sendUnsuccessSearchEvent);
        this.$bus.$on(ERASE_SEARCH_STRING, this.sendEraseSearchStringEvent);

        window.addEventListener('online', this.checkStorageOfflineEvents);
        this.checkStorageOfflineEvents();
    },
    beforeDestroy(){
        this.$bus.$off(UI_MAP_READY, this.onMapReady);
        this.$bus.$off(UI_MAP_LOADED, this.onMapReady);
        this.$bus.$off(UI_STEP_SELECTED, this.sendUIGuideStepEvent);

        this.$bus.$off(MAP_OBJECT_HOVERED, this.sendObjectHoverEvent);
        this.$bus.$off(MAP_OBJECT_SELECTED, this.sendObjectClickEvent);
        this.$bus.$off(MAP_SHOW_PATH_STEPS, this.sendMapGuideStepEvent);

        this.$bus.$off(NO_DIRECT_MATCHES, this.noDirectMatches);
        this.$bus.$off(SEARCH_DATA_CHANGE, this.searchDataChange);
        this.$bus.$off(CHECK_SEARCH_VALUE, this.checkSearchValue);
        this.$bus.$off(SUCCESS_SEARCH, this.sendSuccessSearchEvent);
        this.$bus.$off(UNSUCCESS_SEARCH, this.sendUnsuccessSearchEvent);
        this.$bus.$off(ERASE_SEARCH_STRING, this.sendEraseSearchStringEvent);
        window.removeEventListener('online', this.checkStorageOfflineEvents)
    },
    render(){ return null }
}
</script>
